import React, { memo } from 'react'

import * as S from '../style'
import SelectBase from 'components/SelectOptions/SelectBase'

type PropsSelect = {
  id: number
  label: string
  value: string
  optionMap: { [key: string]: { value: any; label: any }[] }
  columnName: string
  requiredFlag: boolean
  onChange: (value: string) => void
  'data-dg-id'?: string
}

const ImportExportSelectRow: React.FC<PropsSelect> = ({
  id,
  optionMap,
  columnName,
  requiredFlag,
  label,
  value,
  onChange,
  'data-dg-id': dataDgId,
}) => {
  const convertToPackageTypeOptions = (): JSX.Element => {
    //@ts-ignore
    const dataOption = optionMap[columnName]

    return (
      <React.Fragment>
        <option value=""></option>
        {(dataOption || []).map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </React.Fragment>
    )
  }

  return (
    <S.SelectInputWrapper data-dg-id={dataDgId}>
      <S.RequiredText data-dg-id={`entry-load-page-required-${id}`}>
        {requiredFlag && '必須'}
      </S.RequiredText>
      <div style={{ width: 145 }} className="label" data-dg-id={`entry-load-page-label-${id}`}>
        {label}
      </div>
      <div style={{ width: 255 }} data-dg-id={`entry-load-page-input-wrapper-${id}`}>
        <SelectBase
          data-dg-id={`entry-load-page-input-${id}`}
          className="w-100 bg-white px-2"
          style={{ height: 40, borderRadius: 4, border: '1px solid #CCC', color: '#000' }}
          value={value}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            onChange(e.target.value)
          }}
        >
          {convertToPackageTypeOptions()}
        </SelectBase>
      </div>
    </S.SelectInputWrapper>
  )
}

export default memo(ImportExportSelectRow)
